import React, { useEffect, useState } from 'react'
import Layout from '../../../components/Layout/Layout'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'

const AdminPackingListIndex = () => {
  const navigate = useNavigate()
  const [groups, setGroups] = useState([])

  const fetchGroups = async () => {
    try {
      const { data } = await axios.get('/api/v1/admin/packing-list/groups')
      if (data.success) {
        setGroups(data.data)
      } else {
        console.error('Failed to fetch groups')
      }
    } catch (error) {
      console.error('Error fetching groups:', error)
    }
  }

  useEffect(() => {
    fetchGroups()
  }, [])

  const handleViewDetails = (id) => {
    navigate(`/admin/packing-list/details/${id}`)
  }

  const handleReturnHome = () => {
    navigate('/admin/dashboard')
  }

  // Reset Form 1 book records
  const handleResetData = async () => {
    const ok = window.confirm('Confirm reset records?')
    if (!ok) return

    try {
      const { data } = await axios.delete(
        '/api/v1/admin/packing-list/form1/reset'
      )

      if (data?.success) {
        toast.success('Reset successful')
        fetchGroups()
      } else {
        toast.error(data?.message || 'Reset failed')
      }
    } catch (error) {
      console.error('Error resetting Form 1:', error)
      toast.error(error.response?.data?.message || 'Reset failed')
    }
  }

  return (
    <Layout title={'Form 1 - Book Records'}>
      <div className='pt-3 pb-5 mx-3'>
        <div className='d-flex mb-2 justify-content-between align-items-center'>
          <div>
            <h5
              className='mb-0'
              style={{
                color: '#556B2F',
              }}
            >
              Form 1 - Book Records
            </h5>
          </div>

          <div className='d-flex gap-2'>
            <button
              type='button'
              className='btn btn-danger btn-sm me-3'
              onClick={handleResetData}
            >
              <i className='bi bi-exclamation-triangle-fill me-2'></i>
              Reset Data
            </button>

            <button
              type='button'
              className='btn btn-outline-secondary btn-sm'
              onClick={handleReturnHome}
            >
              <i className='bi bi-house-fill'></i>
            </button>
          </div>
        </div>

        <table className='table'>
          <thead>
            <tr>
              <th scope='col'>Group</th>
              <th scope='col'></th>
            </tr>
          </thead>
          <tbody>
            {groups.map((group) => (
              <tr key={group._id}>
                <td>{group.groupName}</td>
                <td className='text-end'>
                  <button
                    type='button'
                    className='btn btn-outline-primary btn-sm'
                    onClick={() => handleViewDetails(group._id)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  )
}

export default AdminPackingListIndex
